import {default as cx} from "classnames"

import {checkIsAdopting} from "../../utilities/useToken"
import {cancelPersona} from "../../utilities/general"

// OARS-877: per-user training units. The backend only honours resets when
// APP_ENVIRONMENT=train; "local" shows the button for local development.
const RESET_UNIT_ENVS = ["train", "local"]

export const AccountDropdownMenu = ({
    userAbbr,
    userName,
    role,
    onClickLogout,
    darkMode,
    setDarkMode,
    onClickResetUnit,
    resettingUnit = false,
}) => {
    const isAdopting = checkIsAdopting()
    const showResetUnit = !!onClickResetUnit && RESET_UNIT_ENVS.includes(window.__APP_CONFIG__?.ENV)
    return (
        <div className="d-flex menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px">
            <div className="menu-item px-3">
                <div className="menu-content d-flex align-items-center px-3">
                    <div className="symbol symbol-40px me-5">
                        <div className={"symbol-label fs-2 fw-semibold bg-primary text-white"}>{userAbbr}</div>
                    </div>
                    <div className="d-flex flex-column">
                        <div className="badge badge-primary fw-bold fs-8 mb-2">{role}</div>
                        <div className="fd-flex align-items-center fs-5">{userName}</div>
                    </div>
                </div>
            </div>

            <div className="separator separator-dotted my-2"></div>

            <div className="menu-item px-5">
                <ul className="p-1">
                    <li
                        role="menuitem"
                        data-rr-ui-dropdown-item=""
                        className="menu-item dropdown-item dropdown-item-text"
                    >
                        <button
                            type="button"
                            className={cx("menu-link w-100 btn", {active: !darkMode})}
                            onClick={() => setDarkMode(false)}
                        >
                            <span className="menu-icon">
                                <i className="fas fa-sun fs-2 text-muted"></i>
                            </span>
                            <span className="menu-title">Light</span>
                        </button>
                    </li>
                    <li
                        role="menuitem"
                        data-rr-ui-dropdown-item=""
                        className="menu-item dropdown-item dropdown-item-text"
                    >
                        <button
                            type="button"
                            className={cx("menu-link w-100 btn", {active: !!darkMode})}
                            onClick={() => setDarkMode(true)}
                        >
                            <span className="menu-icon">
                                <i className="fas fa-moon fs-2 text-muted"></i>
                            </span>
                            <span className="menu-title">Dark</span>
                        </button>
                    </li>
                    {showResetUnit && (
                        <li
                            role="menuitem"
                            data-rr-ui-dropdown-item=""
                            className="menu-item dropdown-item dropdown-item-text"
                        >
                            <button
                                type="button"
                                className="menu-link w-100 btn"
                                onClick={onClickResetUnit}
                                disabled={resettingUnit}
                            >
                                <span className="menu-icon">
                                    <i className="fas fa-arrows-rotate fs-2 text-warning"></i>
                                </span>
                                <span className="menu-title">
                                    {resettingUnit ? "Resetting Unit..." : "Reset My Unit"}
                                </span>
                            </button>
                        </li>
                    )}
                </ul>
            </div>
            {isAdopting && window.__APP_CONFIG__?.ENV && window.__APP_CONFIG__.ENV !== "prod" && (
                <div className="menu-item px-5">
                    <div className="menu-link px-5" onClick={cancelPersona}>
                        <span className="menu-icon">
                            <i className="fas fa-rotate-left fs-2 text-primary"></i>
                        </span>
                        <span>Cancel Persona</span>
                    </div>
                </div>
            )}
            <div className="separator separator-dotted my-2"></div>
            <div className="d-flex px-3">
                <a
                    href="/logoutnav"
                    className="btn btn-primary btn-sm btn btn-flex w-100 px-4 hover-elevate-down justify-content-center"
                    onClick={onClickLogout}
                >
                    Log Out
                </a>
            </div>
        </div>
    )
}

export default AccountDropdownMenu
